<template>
  <header class="flex flex-col items-center gap-200 px-200 mb-200 text-center">
    <LcProgressIndicator v-bind="{ icon, progress }" variant="success" />

    <h1 v-if="$slots.headline" class="headline-h4-headline">
      <slot name="headline" />
    </h1>

    <slot />
  </header>
</template>

<script lang="ts" setup>
import type { LcProgressIndicatorProps } from '@lottocom/frontend-components'

type ProgressHeaderProps = Pick<LcProgressIndicatorProps, 'icon' | 'progress'>

defineProps<ProgressHeaderProps>()
</script>
